$(function() {
    let $processSec = $('.js-process-sec'),
        $ourClientsSec = $('.js-our-clients-sec'),
        $propertiesSec = $('.js-properties-sec'),
        $leadershipCarouselSec = $('.js-leadership-carousel-sec'),
        $textDescColsSec = $('.js-text-desc-cols-sec'),
        $latestNewsSec = $('.js-latest-news-sec'),
        $heroSectorsSec = $('.js-hero-sectors-sec'),
        $sectorsOverviewSec = $('.js-sectors-overview-sec'),
        $featuredCSSec = $('.js-featured-cs-sec'),
        $singlePostPhImg = $('.content-single-post__content p > img');

    function hasClass(section, nextSectionClass, addClass) {
        section.each(function() {
            if ($(this).next().hasClass(nextSectionClass)) {
                $(this).addClass(addClass);
            }
        });
    }

    hasClass($processSec, 'featured-case-studies', 'featured-case-studies-sec');
    hasClass($processSec, 'gallery', 'gallery-sec');
    hasClass($processSec, 'active-listings', 'active-listings-sec');

    hasClass($ourClientsSec, 'latest-news', 'latest-news-sec');

    hasClass($propertiesSec, 'featured-case-studies', 'featured-case-studies-sec');

    hasClass($leadershipCarouselSec, 'other-locations', 'other-locations-sec');

    hasClass($textDescColsSec, 'properties', 'properties-sec');

    hasClass($latestNewsSec, 'our-clients', 'our-clients-sec');
    hasClass($latestNewsSec, 'find-people-search', 'find-people-search-sec');
    hasClass($latestNewsSec, 'process', 'process-sec');

    hasClass($heroSectorsSec, 'sectors', 'sectors-sec');

    hasClass($sectorsOverviewSec, 'events', 'events-sec');
    hasClass($sectorsOverviewSec, 'featured-locations', 'featured-locations-sec');

    hasClass($featuredCSSec, 'our-clients', 'our-clients-sec');

    if ($singlePostPhImg) {
        $singlePostPhImg.parent().addClass('ph-img');
    }
});